import { MutableCustomer } from "shared";

export async function saveCustomerInfo(customer: MutableCustomer) {
  const response = await fetch(`${window.location.origin}/api/customer`, {
    headers: {
      "content-type": "application/json",
    },
    method: "PUT",
    body: JSON.stringify(customer),
  });

  if (!response.ok) {
    throw response;
  }
}
